// Angular
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-cookie-policy',
    templateUrl: './cookie-policy.component.html',
    styleUrls: ['./cookie-policy.component.scss'],
    standalone: false
})
export class CookiePolicyComponent implements OnInit {
    languageCode: 'nl' | 'fr' = 'nl';

    constructor(private activatedRoute: ActivatedRoute) {}

    ngOnInit() {
        this.languageCode = this.activatedRoute.snapshot.params['language_code'];
    }

    onSelectLanguageCode(lang: 'nl' | 'fr') {
        window.open(`/${lang}/cookie-policy`, '_self');
    }
}
